module.exports = __webpack_public_path__ + "static/media/apple-store.9b726927.png";